var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1474_15137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0H2a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z",
    fill: "#50ABF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24 23.72a13.705 13.705 0 0 0 7.363 2.133c7.608 0 13.775-6.168 13.775-13.775 0-.19-.004-.378-.011-.566.275-.217 1.977-1.581 2.394-2.458 0 0-1.382.574-2.735.71h-.008l.007-.004c.125-.084 1.867-1.27 2.103-2.683 0 0-.977.522-2.346.978-.227.075-.464.15-.708.218a4.832 4.832 0 0 0-8.237 4.397c-.374-.016-6.056-.334-9.921-5.015 0 0-2.31 3.153 1.377 6.397 0 0-1.121-.045-2.088-.623 0 0-.355 3.821 3.82 4.798 0 0-.822.311-2.132.09 0 0 .733 3.087 4.442 3.375 0 0-2.933 2.65-7.097 2.028h.001z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1474_15137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#fff"
  })))));
};
export default SvgTwitter;